import React, { Fragment } from 'react'
import styled, { ThemeProvider } from 'styled-components'
import { Grid, Row, Col } from 'react-styled-flexboxgrid'

import Center from '~/components/basic/Center'
import WHATS_NEXT_ITEMS from './whatsNextItems'

const ItemContainer = styled.div`
  color: ${props => props.theme.colors.text.label};
  font-family: ${props => props.theme.fonts.avenirNextMedium};
  line-height: 1.4375rem;
  font-size: 1rem;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
`

const SeperatorContainer = styled.div`
  padding: 3rem 0 0 0;
`

const SpacerLine = styled.div`
  height: 1px;
  background-color: #d8d8d8;
  width: 100%;
`

const theme = {
  flexboxgrid: {
    gridSize: 18,
    gutterWidth: '0',
    outerMargin: '1',
    mediaQuery: 'only screen',
    container: {
      sm: 46,
      md: 61,
      lg: 76
    },
    breakpoints: {
      xs: 0,
      sm: 48,
      md: 64,
      lg: 75
    }
  }
}

const ItemColSize = {
  lg: 5,
  md: 5,
  sm: 5,
  xs: 5
}

const SpacerColSize = {
  lg: 1.5,
  md: 1.5,
  sm: 1.5,
  xs: 1.5
}

const DesktopWhatsNext = () => {
  return (
    <ThemeProvider theme={theme}>
      <Grid style={{ width: '100%' }}>
        <Row>
          {WHATS_NEXT_ITEMS.sort((a, b) => a.desktopOrder - b.desktopOrder).map(
            (item, index) => {
              return (
                <Fragment key={item.altText}>
                  <Col {...ItemColSize}>
                    <ItemContainer>
                      <Center>
                        <img src={item.iconSrc} alt={item.altText} />
                      </Center>
                      {item.desktopText.map((text, textIndex) => {
                        return (
                          <Fragment key={text}>
                            <div>{text}</div>
                            {textIndex !== item.desktopText.length - 1 ? (
                              <div>•</div>
                            ) : null}
                          </Fragment>
                        )
                      })}
                    </ItemContainer>
                  </Col>
                  {index !== WHATS_NEXT_ITEMS.length - 1 ? (
                    <Col {...SpacerColSize}>
                      <SeperatorContainer>
                        <SpacerLine />
                      </SeperatorContainer>
                    </Col>
                  ) : null}
                </Fragment>
              )
            }
          )}
        </Row>
      </Grid>
    </ThemeProvider>
  )
}

export default DesktopWhatsNext
